import LatestNewsImage from "../../../assets/images&icons/LatestNews.png";
import { useNavigate } from "react-router-dom";
import ChevronRight from "../../../components/Atomos/Icons/ChevronRight";

interface ILatestNews {
  data?: any[];
}

const LatestNews: React.FC<ILatestNews> = () => {
  const navigate = useNavigate();

  const newsCategories = [
    { name: "World News", path: "/newsfeeds" },
    { name: "Business News", path: "/newsfeeds?feedlookup=business_top" },
    { name: "Political News", path: "/newsfeeds?feedlookup=political_us" },
    { name: "Africa", path: "/newsfeeds?feedlookup=africa" },
    { name: "Asia Pacific", path: "/newsfeeds?feedlookup=world_asia" },
    { name: "Canada", path: "/newsfeeds?feedlookup=world_canada" },
    { name: "Caribbean", path: "/newsfeeds?feedlookup=dominican_republic" },
    { name: "Europe", path: "/newsfeeds?feedlookup=europe" },
    { name: "Latin America", path: "/newsfeeds?feedlookup=world_south_america" },
    { name: "Middle East", path: "/newsfeeds?feedlookup=world_middle_east" },
    { name: "USA", path: "/newsfeeds?feedlookup=world_us" },
    { name: "Industry News", path: "/newsfeeds?feedlookup=corporate_business_antitrust" },
    { name: "Other News", path: "/newsfeeds" },
    { name: "WSG News", path: "" }
  ];

  const handleCategoryClick = (path: string) => {
    navigate(path);
  };

  return (
    <div className="flex h-full">
      <div
        className="h-full hidden md:block flex-shrink-0"
        style={{
          width: '192px',
          borderRadius: '4px',
          backgroundImage: `url(${LatestNewsImage})`,
          backgroundSize: 'cover',
          backgroundPosition: '100% 30%',
          backgroundRepeat: 'no-repeat',
        }}
      />
      <div className="w-px bg-gray-100 mx-4 hidden md:block"/>

      <div className="flex-1">
        <div 
          className="flex"
          style={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: 'var(--8, 32px)',
            flex: '1 0 0'
          }}
        >
          <div className="flex flex-col gap-6 flex-1">
            {newsCategories.slice(0, Math.ceil(newsCategories.length / 2)).map((category, index) => (
              <button
                key={index}
                onClick={() => handleCategoryClick(category.path)}
                className="flex items-center gap-2.5 p-0 cursor-pointer group text-left w-full"
              >
                <span 
                  className="flex-1 text-gray-font hover:text-primary font-sans text-sm md:text-lg"
                >
                  {category.name}
                </span>
                <div className="w-6 h-6 bg-blue-500 rounded-full flex items-center justify-center text-white p-[.4rem]">
                  <ChevronRight />
                </div>
              </button>
            ))}
          </div>
          
          <div className="flex flex-col gap-6 flex-1">
            {newsCategories.slice(Math.ceil(newsCategories.length / 2)).map((category, index) => (
              <button
              key={index}
              onClick={() => handleCategoryClick(category.path)}
              className="flex items-center gap-2.5 p-0 cursor-pointer group text-left w-full"
            >
              <span 
                className="flex-1 text-gray-font hover:text-primary font-sans text-sm md:text-lg"
              >
                {category.name}
              </span>
              <div className="w-6 h-6 bg-blue-500 rounded-full flex items-center justify-center text-white p-[.4rem]">
                <ChevronRight />
              </div>
            </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LatestNews;
